var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "time-by-project-chart" },
    [
      _c("pie-chart", {
        attrs: {
          "chart-data": _vm.chartData,
          options: _vm.options,
          styles: { height: "100%", position: "relative" }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }